import { Accordion } from "@volkswagen-onehub/components-core";
import React, { ReactElement, ReactNode, useState } from "react";
import { useLocation } from "react-router-dom";
import { useFeatureServices } from "../use-feature-services";
import { getSingleSelectedDealer } from "../utils/get-single-selected-dealer";
import { getStep } from "../utils/get-step";
import { createConfiguration, createConstantData, createPartner, createProcess } from "../utils/get-tracking-event-data";
import { useDealersStore } from "../utils/use-dealers-store";

interface Props {
  id: string;
  question: ReactElement;
  answer: ReactNode;
  onClick?: () => void;
  defaultOpen?: boolean
};

export const Question = ({
  id,
  question,
  answer,
  onClick,
  defaultOpen = false
}: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);
  const { tracking } = useFeatureServices();
  // const lang = getLang();
  const route = useLocation();
  const step = getStep(route.pathname);
	const dealer = useDealersStore().localDealer
  const partner = dealer || getSingleSelectedDealer();

  return (
    <Accordion
      id={id}
      headline={question}
      isOpen={isOpen}
      onClick={() => {
        if (!isOpen) {
          tracking.track('VWBasic_AccordionOpen_Click', {
            ...createConstantData(),
            configuration: createConfiguration(),
            partner: createPartner(partner),
            process: createProcess(step),
            link: {
              url: window.location.href,
              name: question.props.children
            },
            filter: {
              name: undefined
            },
            accordion: {
              groupItemName: question.props.children,
              groupItemState: 'open'
            }
          });
        } else {
          tracking.track('VWBasic_AccordionClose_Click', {
            ...createConstantData(),
            configuration: createConfiguration(),
            partner: createPartner(partner),
            process: createProcess(step),
            link: {
              url: window.location.href,
              name: question.props.children
            },
            filter: {
              name: undefined
            },
            accordion: {
              groupItemName: question.props.children,
              groupItemState: 'closed'
            }
          });
        }
        setIsOpen(!isOpen);
        onClick && onClick();
      }}
    >
      { answer }
    </Accordion>
  );
};
